import { API } from 'shared/constants/api';
import { appApi } from './api';
import { PaymentMethod, PaymentMethodResponse } from './types';

export const paymentApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentMethods: builder.query<PaymentMethod[], any>({
      query: () => ({ url: API.payment.payment_method_order_b2b }),
      transformResponse: (response: PaymentMethodResponse) => {
        if (response.message !== 'OK') return [];
        return response.data.filter((p) => p.enable);
      },
    }),
  }),
});

export const { useGetPaymentMethodsQuery } = paymentApi;
